export interface ConsultationSource {
    sourceId: string;
    sourceType: SourceTypeEnum;
}

export enum SourceTypeEnum {
  MultiprofessionalProtocol = "multiprofessional_protocol",
  MultiprofessionalMeeting = "multiprofessional_meeting",
}
